// extracted by mini-css-extract-plugin
module.exports = {"message":"_e2d7ef2"};